(function () {
  'use strict';

  angular
    .module('doubleSectorCount')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('doubleSectorCount', {
        url: '/double-sector-count',
        views: {
          'doubleSectorCountView': {
            templateUrl: 'double-sector-count/views/double-sector-count.tpl.html',
            controller: 'doubleSectorCountCtrl',
            controllerAs: 'doubleSectorCount'
          }
        }
      });
  }
}());
